import styled, { css } from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';

export const MOBILE_CREATE_BUTTON_SIZE = '2.25rem';

export const MobileCreateButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${MOBILE_CREATE_BUTTON_SIZE};
  height: ${MOBILE_CREATE_BUTTON_SIZE};
  border-radius: 50%;
  background: ${(props: ThemeProp) => props.theme.gradients.button.default};

  svg {
    width: 0.9rem;
    height: 0.9rem;
    path {
      stroke: ${(props: ThemeProp) => props.theme.colors.black};
    }
  }
`;

export const mobileCreateButtonFABPartial = css`
  display: none;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
    bottom: 4.625rem; // 10px + mobile navigation bar height
  }
`;

export default MobileCreateButton;
